module.exports = __webpack_public_path__ + "static/9c444323.04.gif";